import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { IUser } from '../../shared/models/adminModels'
import { get } from 'lodash';

interface IProps {
    user: IUser;
    showSidebar: (flag: boolean) => void;
    sidebar: boolean;
    hideSidebarIcon?:boolean;
}

const Header = (props: IProps) => {
    const displaySidebar = (value: boolean) => {
        props.showSidebar(value)
    }
    const { user } = props;
    return (
        <header className="topbar">
            <div className="brand-logo">
                <Link to="/main-dashboard">
                    <img src="/assets/images/logo.png" />
                </Link>
            </div>
            {!props.hideSidebarIcon && <div className="menu-toggle">
                {/* <span className={'header-user-detail'}>
                    {get(user,'contactFirstName','')} {get(user,'contactSurname','')}
                </span> */}
                <a className="sidebartoggler" onClick={() => displaySidebar(!props.sidebar)}>
                    <FontAwesomeIcon icon={!props.sidebar ? faBars : faTimes} />
                </a>
            </div>
            }
        </header>
    )
}

const mapStateToProps = (state:any) => ({
    user: state.auth.user
})

export default connect(mapStateToProps)(Header);
